import { configureStore } from "@reduxjs/toolkit";

import checklistReducer from "./store/checklistSlice";
import metaReducer from "./store/metaSlice";

/**************************
 * 
 * DO NOT USE REDUX STORE IN NEW CODE
 * FILES SHOULD USE REACT CONTEXT OR REACT QUERY INSTEAD
 * REMOVE WHEN POSSIBLE
 * 
 * 
 * 
 */

export const store = configureStore({
  reducer: {
    checklist: checklistReducer,
    meta: metaReducer,

  },
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
